import { render, staticRenderFns } from "./BookAdd.vue?vue&type=template&id=a31e4b4a"
import script from "./BookAdd.vue?vue&type=script&lang=ts"
export * from "./BookAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports